import { useState, ReactNode, useMemo } from 'react'
import cn from 'classnames'

import { useRouter } from 'next/router'
import urls from 'utilities/urls'
import { Button } from 'components/design-system/button'
import {
  ArrowRightIcon,
  LoadingIcon,
} from 'components/design-system/kickoff-icons'
import { LandingPageExperimentAnalytics } from 'components/homepage/experiment/analytics'
import s from './styles.module.css'

interface INavbarCtaButton {
  children: ReactNode
  className?: string
}

const NavbarCtaButton = ({ children, className }: INavbarCtaButton) => {
  const [submitting, setSubmitting] = useState<boolean>(false)

  const onClick = () => {
    if (submitting) return

    setSubmitting(true)
    LandingPageExperimentAnalytics.onClick({
      signUpVariant: null,
      location: `Blog Nav - CTA`,
    })
  }

  const { query } = useRouter()
  const href = useMemo(() => {
    if (query.ref_coach) {
      return urls.coachReferral({ username: query.ref_coach })
    }

    return urls.insuranceSignUp({
      ref: 'blog',
      gclid: query.gclid,
      msclkid: query.msclkid,
      utm_campaign_id: query?.utm_campaign_id || null,
      utm_campaign: query?.utm_campaign || 'blog',
      utm_medium: query?.utm_medium || 'blog',
      utm_content: query?.utm_content || null,
    })
  }, [
    query.gclid,
    query.msclkid,
    query.ref_coach,
    query.utm_campaign,
    query.utm_campaign_id,
    query.utm_content,
    query.utm_medium,
  ])

  return (
    <Button
      size="small"
      className={cn(s.cta, className)}
      onClick={onClick}
      to={href}
      disabled={submitting}>
      {children || 'Get Started'}
      {submitting ? <LoadingIcon className={s.spin} /> : <ArrowRightIcon />}
    </Button>
  )
}

export default NavbarCtaButton
